<template>
  <div v-if="configReady">
    <aru-autoform
      dismiss-button
      @dismiss="dismiss"
      @submit="submit"
      v-model="fileDoc"
      :form-configuration="config.threadForm"
    ></aru-autoform>
    <v-snackbar v-model="snack" bottom right :timeout="3000" :color="snackColor">
      {{ snackText }}
    </v-snackbar>
  </div>
</template>

<script>
import AruAutoform from '@/components/commons/form/AruAutoForm.vue';
import apiCtrl from '@/services/api/abstract/abstract-api.js';

export default {
  components: {
    AruAutoform,
  },
  props: {
    categoryId: {
      type: [Number],
    },
    month: {
      type: String,
    },
    userId: {
      type: Number,
    },
  },
  data() {
    return {
      config: {},
      configReady: false,
      fileDoc: {},
      snack: false,
    };
  },
  mounted() {
    this.configReady = false;
    if (this.month) {
      this.fileDoc.month = this.month;
    }
    if (this.categoryId) {
      this.fileDoc['sync[categories]'] = this.categoryId;
    }
    if (this.userId) {
      this.fileDoc.user_id = this.userId;
    }
    apiCtrl.get('/config/document').then(res => {
      this.config = res.data.data;
      console.log({ CONFIGURATION: this.config });
      this.configReady = true;
    });
  },
  methods: {
    showSnackMessage(action, message) {
      this.snackColor = action;
      this.snackText = message;
      this.snack = true;
    },
    dismiss() {
      this.$emit('closeDialog');
    },
    submit() {
      let formData = new FormData();

      /*
          Add the form data we need to submit
      */
      let fileSize = null;
      for (const field in this.fileDoc) {
        if (this.fileDoc.hasOwnProperty(field)) {
          const value = this.fileDoc[field];
          fileSize = value.size;
          formData.append(field, value);
        }
      }

      /* NOTE: Check filesize    */
      if (fileSize && fileSize / 1000000 < 10) {
        apiCtrl.postUpload('/document', formData).then(res => {
          console.log(res);
          this.$emit('postdocument', res.data);
        });
      } else {
        this.showSnackMessage('error', 'El tamaño del fichero no puede superar los 10MB');
      }
    },
  },
};
</script>

<style></style>
